import { ArrowLeftIcon } from '@assets/icons';
import { Banner } from '@components/banner';
import { IconButton } from '@components/button';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { useTheme } from '@mui/material';
import { map, size, slice, upperFirst } from 'lodash';

type VolumeExplorerBannerProps = {
  directory: string[];
  name: string;
  permission: string;
  onDirectoryChange: (directory: string[]) => void;
  onExplorerExit: () => void;
};

export const VolumeExplorerBanner = ({
  directory,
  name,
  permission,
  onDirectoryChange,
  onExplorerExit,
}: VolumeExplorerBannerProps) => {
  const { palette } = useTheme();

  return (
    <Banner>
      <Group alignItems="center" height="100%" gap={2}>
        {directory.length > 0 ? (
          <IconButton
            Icon={ArrowLeftIcon}
            onClick={() => onDirectoryChange(slice(directory, 0, size(directory) - 1))}
          />
        ) : (
          <IconButton Icon={ArrowLeftIcon} onClick={onExplorerExit} />
        )}
        <Group>
          {map([`${name}/`, ...directory], (history, index) => (
            <Typography
              key={`title-${index}`}
              variant="subtitle1"
              sx={{
                cursor: 'pointer',
                color: palette.common.white,
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
              onClick={() => onDirectoryChange(slice(directory, 0, index))}
            >
              {history || '-'}
            </Typography>
          ))}
        </Group>
        <Typography variant="body2" color="grey.500" sx={{ pointerEvents: 'none' }}>
          -
        </Typography>
        <Typography variant="body2" color="grey.500" sx={{ pointerEvents: 'none' }}>
          {upperFirst(permission)}
        </Typography>
      </Group>
    </Banner>
  );
};
